import { useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'

function useCookiesBannerItem(): PageBannerCarouselItem | null {
  const intl = useIntl()
  const [areCookiesEnabled, setCookiesAreEnabled] = useState(true)

  useEffect(() => {
    if (window.navigator.cookieEnabled) {
      setCookiesAreEnabled(true)
    } else {
      document.cookie = 'cookietest=1'
      setCookiesAreEnabled(document.cookie.includes('cookietest='))
      document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
    }
  }, [])

  return useMemo(() => {
    if (areCookiesEnabled) return null

    return {
      id: 'cookies-disabled',
      kind: 'warning',
      children: intl.formatMessage({
        id: 'KQ3C4i6G-FhOhuNsW6m0',
        defaultMessage: 'Oops! Your browser seems to have cookies disabled. Make sure cookies are enabled or open a new window.',
        description: 'Warning message displayed when browser cookies are disabled',
      }),
    }
  }, [areCookiesEnabled, intl])
}

export default useCookiesBannerItem
